"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var interpreter_utils_1 = require("../../../interpreter-utils");
var lodash_1 = require("lodash");
var ConditionReader = /** @class */ (function () {
    function ConditionReader(predecessor) {
        this.predecessor = predecessor;
    }
    ConditionReader.prototype.read = function (key, value) {
        if (this.isSupported(key)) {
            if (lodash_1.isPlainObject(value)) {
                value = Object.keys(value).map(function (objKey) { return value[objKey]; })[0];
            }
            else if (Array.isArray(value) && interpreter_utils_1.allArrayItemsArePlainObjects(value)) {
                value = value.map(function (item) { return Object.keys(item).map(function (objKey) { return item[objKey]; })[0]; });
            }
            return this.internalRead(key, value);
        }
        else if (this.predecessor) {
            return this.predecessor.read(key, value);
        }
        else {
            throw new Error("predecessor was not defined for reader");
        }
    };
    return ConditionReader;
}());
exports.ConditionReader = ConditionReader;
//# sourceMappingURL=condition-reader.js.map